import 'whatwg-fetch'
import 'formdata-polyfill'

import Vue from 'vue'
import './plugins/element.js'

import App from './App.vue'
import router from './router'

import VueCountdown from '@xkeshi/vue-countdown'
import VueQRCodeComponent from './core/QrCode.vue'
import SystemInfo from './core/SystemInfo.vue'
import TechnicalAlert from './core/TechnicalAlert.vue'
import i18n from './i18n'

Vue.component('qr-code', VueQRCodeComponent)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component(SystemInfo.name, SystemInfo)
Vue.component(TechnicalAlert.name, TechnicalAlert)

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

// if (document.cookie.indexOf('o=true') > -1) {
//   location.assign(location.origin)
// } else {
  new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app')
// }
